var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserProfileBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 235,
    height: 235,
    viewBox: "0 0 235 235",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 117.5,
    cy: 117.5,
    r: 117.5,
    fill: "#F1F2F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M117.5 114C132.136 114 144 102.136 144 87.5C144 72.8645 132.136 61 117.5 61C102.864 61 91 72.8645 91 87.5C91 102.136 102.864 114 117.5 114Z",
    stroke: "#C8CDD3",
    strokeWidth: 12.21,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M172.5 182.5C166 159 147.246 141 118 141C88.7544 141 69.5 159 64 182.5",
    stroke: "#C8CDD3",
    strokeWidth: 12.21,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserProfileBg);
export default __webpack_public_path__ + "static/media/user_profile_bg.f1954bb5f63d8073d71c37b723b9c406.svg";
export { ForwardRef as ReactComponent };